// import { Imóvel, Empreendimento } from "smart-imob-types";

export const dormitorios = [
  {
    value: 1,
    label: "1 Dormitório"
  },
  {
    value: 2,
    label: "2 Dormitórios"
  },
  {
    value: 3,
    label: "3 Dormitórios"
  },
  {
    value: 4,
    label: "4 Dormitórios"
  },
  {
    value: 5,
    label: "5 Dormitórios"
  }
];
export const vagas = [
  {
    value: 1,
    label: "1 vaga"
  },
  {
    value: 2,
    label: "2 vagas"
  },
  {
    value: 3,
    label: "3 vagas"
  },
  {
    value: 4,
    label: "4 vagas"
  },
  {
    value: 5,
    label: "5 vagas"
  }
];
export const banheiros = [
  {
    value: 1,
    label: "1 banheiro"
  },
  {
    value: 2,
    label: "2 banheiros"
  },
  {
    value: 3,
    label: "3 banheiros"
  },
  {
    value: 4,
    label: "4 banheiros"
  },
  {
    value: 5,
    label: "5 banheiros"
  }
];
export const suites = [
  {
    value: 1,
    label: "1 suíte"
  },
  {
    value: 2,
    label: "2 suítes"
  },
  {
    value: 3,
    label: "3 suítes"
  },
  {
    value: 4,
    label: "4 suítes"
  },
  {
    value: 5,
    label: "5 suítes"
  }
];

export const hospedes = [
  {
    value: 1,
    label: "1 hóspede"
  },
  {
    value: 2,
    label: "2 hóspedes"
  },
  {
    value: 3,
    label: "3 hóspedes"
  },
  {
    value: 4,
    label: "4 hóspedes"
  },
  {
    value: 5,
    label: "5 hóspedes"
  }
];
